import React, { useState } from 'react';
import './PDFBox.css';
export default function PDFBox(props) {
  return (
    <div className="pdf-box-container">
      <iframe title="Legal Document" src={props.pdfUrl}/>
    </div>
  );
}